import { ApolloError, makeVar } from '@apollo/client';

export interface IIkigaiJobCache {
  error: ApolloError | undefined;
  data: string[];
}

export const emptyIkigaiJobCache: IIkigaiJobCache = {
  error: undefined,
  data: [],
};

export const ikigaiJobsVar = makeVar<IIkigaiJobCache>(emptyIkigaiJobCache);
